/**
 * api接口统一管理
 */
import { get,post } from './http'

// 获取菜单导航
export const MenuNavListApi = (params) => get('api/home/menu',params);
// 大会概况
export const SurveyApi = (params) => get('api/home/survey',params);
// 组织机构
export const OrganizedApi = (params) => get('api/home/organization',params);
// 特邀嘉宾
export const SpecialGuestApi = (params) => get('api/home/guest',params);
// 大会议题
export const AgendaApi = () => get('api/home/issue');
// 日程安排
export const DailyScheduleApi = (topicId) => get('api/seminar/'+ 4 +'/seminar-topic/'+ topicId);
// 新闻中心menu
export const NewsCenterApi = (topicId) => get('api/seminar/'+ 4 +'/seminar-topic/'+ topicId);
// 新闻中心
export const NewsCenterListApi = (params,topicId,subTopicId) => get('api/seminar/'+ 4 +'/seminar-topic/'+ topicId +'/seminar-sub-topic/'+ subTopicId +'/seminar-news',params);
// 新闻详情
export const NewsCenterDetailApi = (topicId,subTopicId,newslistId) => get('api/seminar/'+ 4 +'/seminar-topic/'+ topicId +'/seminar-sub-topic/'+ subTopicId +'/seminar-news/'+ newslistId);
// 新闻中心All
export const NewsAllApi = (params) => get('api/seminar-news/all',params);
// 大会指南
export const GuideApi = () => get('api/seminar/'+ 4 +'/seminar-topic/'+ 8);
// 主题演讲
export const KeynoteSpeechAllApi = (params) => get('api/home/speech',params);
// 主题演讲二级
export const KeynoteSpeechApi = (params) => get('api/home/videos',params);
// 现场花絮
export const LiveHighlightsAllApi = (params) => get('api/home/scene',params);
// 现场花絮二级
export const LiveHighlightsApi = (params) => get('api/seminar/4/seminar-topic/12/sortable',params);

// 访问记录
export const AccessRecordsApi = (params) => post('api/seminar-visit',params);



// WEBPACK FOOTER //
// ./src/request/api.js